/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React from "react";

import SweetAlert from "sweetalert2-react";

import { connect } from "react-redux";
import { urlDecode } from "../../helpers";
import { getPartner, submitTestimonial } from "../../actions/partners";

import LoadingIndicator from "../../shared/components/LoadingIndicator";
import { isFetching, isSuccess } from "../../reducers/reducerUtils";

import { Row, Col, Card, CardHeader, Container } from "reactstrap";
import Image from "react-graceful-image";

import RatingsField from "../../shared/components/form/RatingsField";
import Textarea from "../../shared/components/form/Textarea";
import VideoRecorder from "../../shared/components/VideoRecorder";
import hero1 from "../../assets/images/hero-bg/hero-1.jpg";
import { Formik, Field } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  rating: Yup.number().moreThan(0, "Rating is required"),
  comments: Yup.string().when("videoToken", {
    is: value => !value || value.length === 0,
    then: Yup.string().required("Testimonial is required")
  })
});

class AddTestimonial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      addingTestimonial: false,
      testimonialAdded: false,
      params: JSON.parse(urlDecode(this.props.location.search))
    };
  }

  componentDidMount = () => {
    const { params } = this.state;
    if (params) {
      this.props.getPartner(params.partner_slug);
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    // We need to look at the params and fetch the partner information
    // and contact information.
    const {
      partnerInfo,
      getPartnerSuccess,
      testimonial
    } = nextProps.partnerProp;

    if (prevState.loading && partnerInfo) {
      if (getPartnerSuccess) {
        return {
          loading: false,
          partner: partnerInfo
        };
      } else {
        return {
          loading: false,
          partner: null,
          error: partnerInfo.error
        };
      }
    } else if (prevState.addingTestimonial) {
      if (!isFetching(testimonial)) {
        if (isSuccess(testimonial)) {
          return {
            addingTestimonial: false,
            testimonialAdded: true
          };
        }
      }
    }
    return null;
  }

  onSubmit = values => {
    const { params } = this.state;
    this.setState({ addingTestimonial: true }, () => {
      this.props.submitTestimonial(Object.assign({}, values, params));
    });
  };

  render() {
    const { loading, partner, testimonialAdded } = this.state;

    const initialValues = {
      rating: 0,
      comments: "",
      videoToken: null
    };

    if (loading) return <LoadingIndicator />;

    if (testimonialAdded) {
      return (
        <SweetAlert
          title="Testimonial added"
          confirmButtonColor=""
          show={true}
          text="Thanks for adding your testimonial"
          type="success"
          onConfirm={() => this.props.history.push("/")}
        />
      );
    }
    return (
      <div className="hero-wrapper--content bg-composed-wrapper bg-second">
        <div
          className="bg-composed-wrapper--image"
          style={{ backgroundImage: "url(" + hero1 + ")" }}
        />
        <div className="bg-composed-wrapper--bg bg-premium-dark opacity-5" />
        <div className="bg-composed-wrapper--content">
          <Container className="z-over text-white py-0 py-xl-5">
            <Row className="py-5">
              <Col lg="6">
                <div className="text-center text-lg-left py-0 pr-0 pr-xl-3 py-xl-5">
                  <div className="pr-0 pr-xl-5 text-white">
                    <h1 className="display-3 mb-3 font-weight-bold">
                      {partner.name}
                    </h1>
                    <p className="font-size-xxl m-0 py-3 text-white-50">
                      {partner.bio}
                    </p>
                    <Card className="shadow-xxl p-3">
                      <Card
                        className="card-box shadow-none"
                        style={{ height: 350 }}
                      >
                        <Image
                          src={partner.imageUrl}
                          height="350px"
                          alt="..."
                          style={{ borderRadius: "0.65rem" }}
                        />{" "}
                      </Card>
                    </Card>
                    {/*
                    <div className="d-block mt-4">
                      <Button
                        color="first"
                        className="px-5 font-size-sm font-weight-bold btn-animated-icon text-uppercase rounded shadow-none py-3 hover-scale-sm hover-scale-lg mr-3"
                      >
                        <span className="btn-wrapper--label">Purchase now</span>
                        <span className="btn-wrapper--icon">
                          <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                        </span>
                      </Button>
                    </div> */}
                  </div>
                </div>
              </Col>
              <Col lg="6" className="d-flex align-items-center">
                <Card className="bg-secondary my-3 shadow-xxl w-100 card-box">
                  <CardHeader className="d-flex align-items-center justify-content-between card-header-alt">
                    <div className="text-uppercase font-weight-bold text-black text-center">
                      Testimonial
                    </div>
                  </CardHeader>
                  <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.onSubmit}
                  >
                    {props => {
                      return (
                        <div className="px-3 py-4">
                          <form onSubmit={props.handleSubmit}>
                            <div className="form-group  inputblock ">
                              <label htmlFor="exampleInputEmail1">
                                Ratings:
                              </label>
                              <Field name="rating" component={RatingsField} />
                            </div>
                            <div className="form-group  inputblock ">
                              <label htmlFor="exampleInputEmail1">
                                Testimonial:
                              </label>
                              <Field name="comments" component={Textarea} />
                            </div>

                            <div className="form-group  inputblock ">
                              <label htmlFor="exampleInputEmail1">
                                Video Testimonial:
                              </label>
                              <Field
                                name="videoToken"
                                component={VideoRecorder}
                              />
                            </div>

                            <div className=" text-center">
                              <button
                                type="submit"
                                className="btn btn-primary text-uppercase px-5"
                                disabled={loading}
                              >
                                Add Testimonial
                              </button>
                            </div>
                          </form>
                        </div>
                      );
                    }}
                  </Formik>
                </Card>
              </Col>
            </Row>
          </Container>
          <div className="shape-container-top-1 z-below">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="var(--light)"
                fillOpacity="1"
                d="M0,96L48,112C96,128,192,160,288,176C384,192,480,192,576,202.7C672,213,768,235,864,213.3C960,192,1056,128,1152,133.3C1248,139,1344,213,1392,250.7L1440,288L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  partnerProp: state.partners
});

const mapDispatchToProps = dispatch => {
  return {
    getPartner: slug => getPartner(slug, dispatch),
    submitTestimonial: data => submitTestimonial(data, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTestimonial);
